import settings from '../../config';
import { RouteConfig } from "../types/RouteConfig";

export const digitalSmsRoute: RouteConfig<'external'> = {
    name: 'DFSS',
    url: `${settings.DIGITAL_FOOD_SAFETY_SYSTEM_URL}`,
    icon: 'dripicons-checklist',
    roles: ['ncassMember', 'accountManager'],
    target: '_self',
}

export const legacyMyDetailsRoute: RouteConfig<'external'> = {
    name: 'My Details',
    url: '/maintenance',
    icon: 'dripicons-user',
    roles: ['ncassMember', 'accountManager'],
    target: '_self',
}

export const wordpressContactUsRoute: RouteConfig<'external'> = {
    name: 'Contact Us',
    url: 'https://www.ncass.org.uk/contact-us/',
    icon: 'dripicons-phone',
    roles: ['ncassMember'],
    flags:['member-renew'],
    target: '_self',
}

export const wordpressMemberResourcesRoute: RouteConfig<'external'> = {
    name: 'Member Resources',
    url: 'https://www.ncass.org.uk/members-only-resources/standard-resources/',
    icon: 'mdi mdi-file-document-box-multiple-outline',
    roles: ['ncassMember'],
    target: '_self',
}

export const wordpressFindAGasEngineerRoute: RouteConfig<'external'> = {
    name: 'Find A Gas Engineer',
    url: 'https://www.ncass.org.uk/members-only/gas-engineers/',
    icon: 'mdi mdi-account-search-outline',
    roles: ['ncassMember'],
    target: '_self',
}

export const legacyLocalAuthorityRoute: RouteConfig<'external'> = {
    name: 'My Local Authority',
    url: `${settings.CONTROL_PANEL_URL}/memberarea/member_my_local_authority.aspx`,
    icon: 'mdi mdi-bank',
    roles: ['ncassMember'],
    target: '_self',
}

export const legacyMyWorkOppsRoute: RouteConfig<'external'> = {
    name: 'My WorkOpps',
    url: `${settings.CONTROL_PANEL_URL}/place_workopportunity.aspx`,
    icon: 'mdi mdi-cellphone',
    roles: ['ncassMember', 'accountManager'],
    target: '_self',
}